import PropTypes from "prop-types"
import React from "react"

// A line item whose value is a plain, server-provided string rather than a
// currency amount — e.g. "3% of each payment" for a surcharge rate row.
const TextValue = ({ label, value }) => (
  <div className="flex items-center justify-between text-gray-600">
    <span>{label}</span>
    <span>{value}</span>
  </div>
)

TextValue.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
}

export default TextValue
